import { render, staticRenderFns } from "./LKHeaderUserMenu.vue?vue&type=template&id=09c3f2e9&scoped=true&"
import script from "./LKHeaderUserMenu.vue?vue&type=script&lang=js&"
export * from "./LKHeaderUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./LKHeaderUserMenu.vue?vue&type=style&index=0&id=09c3f2e9&scoped=true&lang=css&"
import style1 from "./LKHeaderUserMenu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c3f2e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
